<template>
  <div>
    <h3>Attributes:</h3>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="value" label="参数" width="100"> </el-table-column>
      <el-table-column prop="describe" label="说明" width="350"> </el-table-column>
      <el-table-column prop="type" label="类型" width="200"> </el-table-column>
      <el-table-column prop="Option" label="可选值" width="300"> </el-table-column>
      <el-table-column prop="default" label="默认值" width="150"> </el-table-column>
      <el-table-column prop="required" label="必填" width="50"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          value: "title",
          describe: "标题文本，可传入图片",
          type: "String",
          Option: "-",
          default: "-",
          required: "true"
        },
        {
          value: "imageTitle",
          describe: "标题参数是否是一个图片地址",
          type: "Boolean",
          Option: "-",
          default: "false",
          required: "false"
        },
        {
          value: " tips",
          describe: "提示框文字",
          type: "String",
          Option: "-",
          default: "-",
          required: "false"
        },
        {
          value: " tipsPosition",
          describe: "提示框位置,参数参考elementui",
          type: "String",
          Option: "-",
          default: "bottom",
          required: "false"
        },
        {
          value: "className",
          describe: "可自定义标题的classname，例如传入一个icon的class",
          type: "String",
          Option: "-",
          default: "''",
          required: "false"
        },
        {
          value: "titlePosition",
          describe: "标题位置，allInOneLine表示和其他组件在同一排，singleLine表示标题单独一排",
          type: "String",
          Option: "allInOneLine/singleLine",
          default: "allInOneLine",
          required: "false"
        },
        {
          value: "suffix",
          describe: "输入框的后缀字符",
          type: "String",
          Option: "-",
          default: "-",
          required: "false"
        },
        {
          value: "value",
          describe: "数据",
          type: "Number",
          Option: "-",
          default: "-",
          required: "true"
        },
        {
          value: "sliderMin",
          describe: "拖动输入框的最小值",
          type: "Number",
          Option: "-",
          default: "0",
          required: "false"
        },
        {
          value: "sliderMax",
          describe: "拖动输入框的最大值",
          type: "Number",
          Option: "-",
          default: "100",
          required: "false"
        },
        {
          value: " inputWidth",
          describe: "input框宽度",
          type: "String",
          Option: "large/small",
          default: "large",
          required: "false"
        },

        {
          value: " inputHeight",
          describe: "input框高度",
          type: "String",
          Option: "large/small",
          default: "large",
          required: "false"
        },
        {
          value: " showSlider",
          describe: "是否显示slider",
          type: "Boolean",
          Option: "true/false",
          default: "true",
          required: "false"
        },
        {
          value: " themeKey",
          describe: "主题色关键字",
          type: "String",
          Option: "bigScreen/portal",
          default: "bigScreen",
          required: "false"
        }
      ]
    }
  }
}
</script>

<style>
</style>